import { useQuery } from "react-query"
import { useState } from "react"
import { getComplaints } from "../../MyApi/complaints"
import HeaderBar from "../../Components/UI/headerbar"
import FilterBar from "../../Components/UI/filterbar"
import DataTable from "../../Components/UI/table/DataTable"

const ComplaintsPage = () => {
  const [current_page, setCurrentPage] = useState(1)

  const { data, isLoading, error, isFetching, refetch } = useQuery(
    ["getComplaints", current_page],
    () => getComplaints(current_page),
    {
      keepPreviousData: true,
    }
  )
    
  const complaints = data?.data?.contact_us || []
  const total = data?.data?.pagination?.total || 0
  const last_page = data?.data?.pagination?.last_page

  const complaintsColumns = [
  { label: "معرف العميل", render:(row)=> <div className="text-green">
    #{row.id}
  </div> },
  { label: "رقم الهاتف", accessor: "phone" },
  { label: "محتوى الشكوى", accessor: "content" },
];

  return (
    <div>
      <HeaderBar title="الشكاوي" content={"إدارة الشكاوي"} />
      
      <DataTable
        columns={complaintsColumns} 
        data={complaints} 
        isLoading={isLoading} 
        totalItems={total} 
        itemsPerPage={last_page} 
        currentPage={current_page} 
        setCurrentPage={setCurrentPage} 
        error={error} 
        onRetry={() => refetch()}
        isFetching={isFetching}
      />
    </div>
  )  
}

export default ComplaintsPage;
